

































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

interface IconOption {
  value: string;
  label: string;
  category: string;
}

@Component
export default class IconSelector extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: "Icono" }) label!: string;
  @Prop({ default: "primary" }) iconColor!: string;

  public menuOpen: boolean = false;
  public search: string = "";
  public currentPage: number = 1;
  public itemsPerPage: number = 48;

  get displayValue(): string {
    if (!this.value) return "";
    const icon = this.icons.find((i) => i.value === this.value);
    return icon ? icon.label : this.value;
  }

  get filteredIcons(): IconOption[] {
    if (!this.search) return this.icons;

    const searchLower = this.search.toLowerCase();
    return this.icons.filter(
      (icon) =>
        icon.label.toLowerCase().includes(searchLower) ||
        icon.value.toLowerCase().includes(searchLower) ||
        icon.category.toLowerCase().includes(searchLower)
    );
  }

  get paginatedIcons(): IconOption[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.filteredIcons.slice(start, end);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredIcons.length / this.itemsPerPage);
  }

  @Watch("search")
  onSearchChange() {
    this.currentPage = 1;
  }

  public selectIcon(iconValue: string) {
    this.$emit("input", iconValue);
  }

  public clearSelection() {
    this.$emit("input", "");
  }

  public onManualInput(value: string) {
    this.$emit("input", value);
  }

  // Lista de iconos más comunes de FontAwesome Pro 5.13 (puedes ampliarla)
  public icons: IconOption[] = [
    // --- NAVEGACIÓN Y UI BÁSICA ---
    { value: "fal fa-home", label: "Home", category: "navigation" },
    { value: "fal fa-bars", label: "Menu", category: "navigation" },
    { value: "fal fa-th", label: "Grid", category: "navigation" },
    { value: "fal fa-th-large", label: "Dashboard", category: "navigation" },
    { value: "fal fa-th-list", label: "List View", category: "navigation" },
    { value: "fal fa-ellipsis-h", label: "More Horiz", category: "navigation" },
    { value: "fal fa-ellipsis-v", label: "More Vert", category: "navigation" },
    { value: "fal fa-cog", label: "Settings", category: "navigation" },
    { value: "fal fa-cogs", label: "Settings Adv", category: "navigation" },
    { value: "fal fa-wrench", label: "Wrench", category: "navigation" },
    { value: "fal fa-sliders-h", label: "Sliders", category: "navigation" },
    { value: "fal fa-search", label: "Search", category: "navigation" },
    { value: "fal fa-search-plus", label: "Zoom In", category: "navigation" },
    { value: "fal fa-search-minus", label: "Zoom Out", category: "navigation" },
    { value: "fal fa-sign-in-alt", label: "Sign In", category: "navigation" },
    { value: "fal fa-sign-out-alt", label: "Sign Out", category: "navigation" },
    { value: "fal fa-power-off", label: "Power Off", category: "navigation" },

    // --- FLECHAS Y DIRECCIONES (Muy usadas) ---
    { value: "fal fa-angle-up", label: "Angle Up", category: "arrows" },
    { value: "fal fa-angle-down", label: "Angle Down", category: "arrows" },
    { value: "fal fa-angle-left", label: "Angle Left", category: "arrows" },
    { value: "fal fa-angle-right", label: "Angle Right", category: "arrows" },
    {
      value: "fal fa-angle-double-up",
      label: "Angle Double Up",
      category: "arrows",
    },
    {
      value: "fal fa-angle-double-down",
      label: "Angle Double Down",
      category: "arrows",
    },
    { value: "fal fa-arrow-up", label: "Arrow Up", category: "arrows" },
    { value: "fal fa-arrow-down", label: "Arrow Down", category: "arrows" },
    { value: "fal fa-arrow-left", label: "Arrow Left", category: "arrows" },
    { value: "fal fa-arrow-right", label: "Arrow Right", category: "arrows" },
    { value: "fal fa-chevron-up", label: "Chevron Up", category: "arrows" },
    { value: "fal fa-chevron-down", label: "Chevron Down", category: "arrows" },
    { value: "fal fa-chevron-left", label: "Chevron Left", category: "arrows" },
    {
      value: "fal fa-chevron-right",
      label: "Chevron Right",
      category: "arrows",
    },
    { value: "fal fa-caret-up", label: "Caret Up", category: "arrows" },
    { value: "fal fa-caret-down", label: "Caret Down", category: "arrows" },
    { value: "fal fa-caret-left", label: "Caret Left", category: "arrows" },
    { value: "fal fa-caret-right", label: "Caret Right", category: "arrows" },
    { value: "fal fa-exchange-alt", label: "Exchange", category: "arrows" },
    { value: "fal fa-random", label: "Random", category: "arrows" },
    { value: "fal fa-sync", label: "Sync", category: "arrows" },
    { value: "fal fa-redo", label: "Redo", category: "arrows" },
    { value: "fal fa-undo", label: "Undo", category: "arrows" },

    // --- USUARIOS Y PERSONAS ---
    { value: "fal fa-user", label: "User", category: "users" },
    { value: "fal fa-user-circle", label: "User Circle", category: "users" },
    { value: "fal fa-user-alt", label: "User Alt", category: "users" },
    { value: "fal fa-users", label: "Users", category: "users" },
    { value: "fal fa-user-plus", label: "Add User", category: "users" },
    { value: "fal fa-user-minus", label: "Remove User", category: "users" },
    { value: "fal fa-user-edit", label: "Edit User", category: "users" },
    { value: "fal fa-user-cog", label: "User Settings", category: "users" },
    { value: "fal fa-user-check", label: "User Check", category: "users" },
    { value: "fal fa-user-times", label: "User Times", category: "users" },
    { value: "fal fa-user-shield", label: "User Shield", category: "users" },
    { value: "fal fa-user-graduate", label: "Graduate", category: "users" },
    { value: "fal fa-user-tie", label: "Professional", category: "users" },
    { value: "fal fa-address-book", label: "Address Book", category: "users" },
    { value: "fal fa-address-card", label: "Address Card", category: "users" },
    { value: "fal fa-id-card", label: "ID Card", category: "users" },
    { value: "fal fa-id-badge", label: "ID Badge", category: "users" },

    // --- ARCHIVOS Y CARPETAS (Ampliado) ---
    { value: "fal fa-folder", label: "Folder", category: "files" },
    { value: "fal fa-folder-open", label: "Folder Open", category: "files" },
    { value: "fal fa-folder-plus", label: "Folder Add", category: "files" },
    { value: "fal fa-folder-minus", label: "Folder Remove", category: "files" },
    { value: "fal fa-file", label: "File", category: "files" },
    { value: "fal fa-file-alt", label: "Text File", category: "files" },
    { value: "fal fa-file-pdf", label: "PDF", category: "files" },
    { value: "fal fa-file-word", label: "Word", category: "files" },
    { value: "fal fa-file-excel", label: "Excel", category: "files" },
    { value: "fal fa-file-powerpoint", label: "PowerPoint", category: "files" },
    { value: "fal fa-file-image", label: "Image", category: "files" },
    { value: "fal fa-file-audio", label: "Audio", category: "files" },
    { value: "fal fa-file-video", label: "Video", category: "files" },
    { value: "fal fa-file-archive", label: "Archive", category: "files" },
    { value: "fal fa-file-code", label: "Code", category: "files" },
    { value: "fal fa-file-csv", label: "CSV", category: "files" },
    {
      value: "fal fa-file-download",
      label: "Download File",
      category: "files",
    },
    { value: "fal fa-file-upload", label: "Upload File", category: "files" },
    { value: "fal fa-copy", label: "Copy", category: "files" },
    { value: "fal fa-paste", label: "Paste", category: "files" },
    { value: "fal fa-clone", label: "Clone", category: "files" },

    // --- COMUNICACIÓN Y REDES ---
    { value: "fal fa-envelope", label: "Envelope", category: "communication" },
    {
      value: "fal fa-envelope-open",
      label: "Open Mail",
      category: "communication",
    },
    {
      value: "fal fa-envelope-open-text",
      label: "Read Mail",
      category: "communication",
    },
    { value: "fal fa-paper-plane", label: "Send", category: "communication" },
    { value: "fal fa-inbox", label: "Inbox", category: "communication" },
    { value: "fal fa-phone", label: "Phone", category: "communication" },
    {
      value: "fal fa-phone-alt",
      label: "Phone Alt",
      category: "communication",
    },
    {
      value: "fal fa-phone-slash",
      label: "No Phone",
      category: "communication",
    },
    { value: "fal fa-mobile-alt", label: "Mobile", category: "communication" },
    { value: "fal fa-comment", label: "Comment", category: "communication" },
    { value: "fal fa-comments", label: "Chat", category: "communication" },
    {
      value: "fal fa-comment-alt",
      label: "Comment Alt",
      category: "communication",
    },
    {
      value: "fal fa-comment-dots",
      label: "Typing",
      category: "communication",
    },
    {
      value: "fal fa-quote-left",
      label: "Quote Left",
      category: "communication",
    },
    {
      value: "fal fa-quote-right",
      label: "Quote Right",
      category: "communication",
    },
    { value: "fal fa-rss", label: "RSS", category: "communication" },
    { value: "fal fa-share-alt", label: "Share", category: "communication" },
    {
      value: "fal fa-share-square",
      label: "Share Box",
      category: "communication",
    },
    { value: "fal fa-bell", label: "Notification", category: "communication" },
    { value: "fal fa-bell-slash", label: "Silent", category: "communication" },

    // --- EDICIÓN Y TEXTO (WYSIWYG) ---
    { value: "fal fa-pen", label: "Pen", category: "editor" },
    { value: "fal fa-edit", label: "Edit", category: "editor" },
    { value: "fal fa-pencil-alt", label: "Pencil", category: "editor" },
    { value: "fal fa-eraser", label: "Eraser", category: "editor" },
    { value: "fal fa-font", label: "Font", category: "editor" },
    { value: "fal fa-bold", label: "Bold", category: "editor" },
    { value: "fal fa-italic", label: "Italic", category: "editor" },
    { value: "fal fa-underline", label: "Underline", category: "editor" },
    {
      value: "fal fa-strikethrough",
      label: "Strikethrough",
      category: "editor",
    },
    { value: "fal fa-align-left", label: "Align Left", category: "editor" },
    { value: "fal fa-align-center", label: "Align Center", category: "editor" },
    { value: "fal fa-align-right", label: "Align Right", category: "editor" },
    { value: "fal fa-align-justify", label: "Justify", category: "editor" },
    { value: "fal fa-list-ul", label: "Bullets", category: "editor" },
    { value: "fal fa-list-ol", label: "Numbers", category: "editor" },
    { value: "fal fa-indent", label: "Indent", category: "editor" },
    { value: "fal fa-outdent", label: "Outdent", category: "editor" },
    { value: "fal fa-link", label: "Link", category: "editor" },
    { value: "fal fa-unlink", label: "Unlink", category: "editor" },
    { value: "fal fa-image", label: "Insert Image", category: "editor" },
    { value: "fal fa-table", label: "Table", category: "editor" },

    // --- ESTADO E INDICADORES ---
    { value: "fal fa-check", label: "Check", category: "status" },
    { value: "fal fa-check-circle", label: "Check Circle", category: "status" },
    { value: "fal fa-check-square", label: "Check Box", category: "status" },
    { value: "fal fa-check-double", label: "Double Check", category: "status" },
    { value: "fal fa-times", label: "Times", category: "status" },
    { value: "fal fa-times-circle", label: "Times Circle", category: "status" },
    { value: "fal fa-plus", label: "Plus", category: "status" },
    { value: "fal fa-plus-circle", label: "Plus Circle", category: "status" },
    { value: "fal fa-minus", label: "Minus", category: "status" },
    { value: "fal fa-minus-circle", label: "Minus Circle", category: "status" },
    { value: "fal fa-exclamation", label: "Exclamation", category: "status" },
    {
      value: "fal fa-exclamation-circle",
      label: "Error Circle",
      category: "status",
    },
    {
      value: "fal fa-exclamation-triangle",
      label: "Warning",
      category: "status",
    },
    { value: "fal fa-info", label: "Info", category: "status" },
    { value: "fal fa-info-circle", label: "Info Circle", category: "status" },
    { value: "fal fa-question", label: "Question", category: "status" },
    { value: "fal fa-question-circle", label: "Help", category: "status" },
    { value: "fal fa-ban", label: "Ban", category: "status" },
    { value: "fal fa-spinner", label: "Spinner", category: "status" },
    { value: "fal fa-circle-notch", label: "Loading", category: "status" },
    { value: "fal fa-lock", label: "Lock", category: "status" },
    { value: "fal fa-unlock", label: "Unlock", category: "status" },
    { value: "fal fa-unlock-alt", label: "Unlock Alt", category: "status" },
    { value: "fal fa-key", label: "Key", category: "status" },
    { value: "fal fa-shield-alt", label: "Shield", category: "status" },
    { value: "fal fa-eye", label: "Eye", category: "status" },
    { value: "fal fa-eye-slash", label: "Eye Slash", category: "status" },

    // --- FECHA Y TIEMPO ---
    { value: "fal fa-calendar", label: "Calendar", category: "date" },
    { value: "fal fa-calendar-alt", label: "Calendar Alt", category: "date" },
    { value: "fal fa-calendar-plus", label: "Add Event", category: "date" },
    { value: "fal fa-calendar-check", label: "Check Event", category: "date" },
    { value: "fal fa-calendar-times", label: "Delete Event", category: "date" },
    { value: "fal fa-calendar-day", label: "Day", category: "date" },
    { value: "fal fa-calendar-week", label: "Week", category: "date" },
    { value: "fal fa-clock", label: "Clock", category: "date" },
    { value: "fal fa-hourglass", label: "Hourglass", category: "date" },
    {
      value: "fal fa-hourglass-half",
      label: "Hourglass Half",
      category: "date",
    },
    { value: "fal fa-history", label: "History", category: "date" },
    { value: "fal fa-stopwatch", label: "Stopwatch", category: "date" },

    // --- NEGOCIOS Y FINANZAS ---
    { value: "fal fa-chart-line", label: "Chart Line", category: "business" },
    { value: "fal fa-chart-bar", label: "Chart Bar", category: "business" },
    { value: "fal fa-chart-pie", label: "Chart Pie", category: "business" },
    { value: "fal fa-chart-area", label: "Chart Area", category: "business" },
    { value: "fal fa-dollar-sign", label: "Dollar", category: "business" },
    { value: "fal fa-euro-sign", label: "Euro", category: "business" },
    { value: "fal fa-money-bill", label: "Money", category: "business" },
    {
      value: "fal fa-money-bill-alt",
      label: "Money Alt",
      category: "business",
    },
    { value: "fal fa-credit-card", label: "Credit Card", category: "business" },
    { value: "fal fa-wallet", label: "Wallet", category: "business" },
    { value: "fal fa-calculator", label: "Calculator", category: "business" },
    { value: "fal fa-shopping-cart", label: "Cart", category: "business" },
    { value: "fal fa-shopping-basket", label: "Basket", category: "business" },
    { value: "fal fa-shopping-bag", label: "Bag", category: "business" },
    { value: "fal fa-tag", label: "Tag", category: "business" },
    { value: "fal fa-tags", label: "Tags", category: "business" },
    { value: "fal fa-barcode", label: "Barcode", category: "business" },
    { value: "fal fa-qrcode", label: "QR Code", category: "business" },
    { value: "fal fa-briefcase", label: "Briefcase", category: "business" },
    { value: "fal fa-building", label: "Building", category: "business" },
    { value: "fal fa-store", label: "Store", category: "business" },
    { value: "fal fa-store-alt", label: "Store Alt", category: "business" },
    {
      value: "fal fa-hand-holding-usd",
      label: "Hand USD",
      category: "business",
    },
    { value: "fal fa-piggy-bank", label: "Piggy Bank", category: "business" },
    { value: "fal fa-percent", label: "Percent", category: "business" },

    // --- DISPOSITIVOS Y HARDWARE ---
    { value: "fal fa-desktop", label: "Desktop", category: "devices" },
    { value: "fal fa-laptop", label: "Laptop", category: "devices" },
    { value: "fal fa-tablet-alt", label: "Tablet", category: "devices" },
    { value: "fal fa-mobile", label: "Mobile", category: "devices" },
    { value: "fal fa-keyboard", label: "Keyboard", category: "devices" },
    { value: "fal fa-mouse", label: "Mouse", category: "devices" },
    { value: "fal fa-print", label: "Print", category: "devices" },
    { value: "fal fa-camera", label: "Camera", category: "devices" },
    { value: "fal fa-video", label: "Video", category: "devices" },
    { value: "fal fa-microphone", label: "Microphone", category: "devices" },
    {
      value: "fal fa-microphone-slash",
      label: "Mute Mic",
      category: "devices",
    },
    { value: "fal fa-headphones", label: "Headphones", category: "devices" },
    { value: "fal fa-hdd", label: "HDD", category: "devices" },
    { value: "fal fa-server", label: "Server", category: "devices" },
    { value: "fal fa-database", label: "Database", category: "devices" },
    { value: "fal fa-wifi", label: "WiFi", category: "devices" },
    {
      value: "fal fa-battery-full",
      label: "Battery Full",
      category: "devices",
    },
    {
      value: "fal fa-battery-half",
      label: "Battery Half",
      category: "devices",
    },
    {
      value: "fal fa-battery-quarter",
      label: "Battery Low",
      category: "devices",
    },

    // --- MAPAS Y UBICACIÓN ---
    { value: "fal fa-map-marker-alt", label: "Marker", category: "maps" },
    { value: "fal fa-map", label: "Map", category: "maps" },
    { value: "fal fa-map-pin", label: "Pin", category: "maps" },
    {
      value: "fal fa-location-arrow",
      label: "Location Arrow",
      category: "maps",
    },
    { value: "fal fa-compass", label: "Compass", category: "maps" },
    { value: "fal fa-route", label: "Route", category: "maps" },
    { value: "fal fa-globe", label: "Globe", category: "maps" },
    { value: "fal fa-globe-americas", label: "Americas", category: "maps" },
    { value: "fal fa-globe-europe", label: "Europe", category: "maps" },
    { value: "fal fa-flag", label: "Flag", category: "maps" },

    // --- MULTIMEDIA ---
    { value: "fal fa-play", label: "Play", category: "media" },
    { value: "fal fa-play-circle", label: "Play Circle", category: "media" },
    { value: "fal fa-pause", label: "Pause", category: "media" },
    { value: "fal fa-pause-circle", label: "Pause Circle", category: "media" },
    { value: "fal fa-stop", label: "Stop", category: "media" },
    { value: "fal fa-stop-circle", label: "Stop Circle", category: "media" },
    { value: "fal fa-forward", label: "Forward", category: "media" },
    { value: "fal fa-backward", label: "Backward", category: "media" },
    { value: "fal fa-step-forward", label: "Next", category: "media" },
    { value: "fal fa-step-backward", label: "Previous", category: "media" },
    { value: "fal fa-fast-forward", label: "Fast Fwd", category: "media" },
    { value: "fal fa-fast-backward", label: "Fast Back", category: "media" },
    { value: "fal fa-expand", label: "Expand", category: "media" },
    { value: "fal fa-compress", label: "Compress", category: "media" },
    { value: "fal fa-volume-up", label: "Vol Up", category: "media" },
    { value: "fal fa-volume-down", label: "Vol Down", category: "media" },
    { value: "fal fa-volume-mute", label: "Mute", category: "media" },
    { value: "fal fa-music", label: "Music", category: "media" },
    { value: "fal fa-film", label: "Film", category: "media" },
    { value: "fal fa-photo-video", label: "Photo Video", category: "media" },

    // --- SOCIAL (Nota: Marcas suelen ser 'fab', pero si usas Pro 'fal' tiene algunas) ---
    { value: "fal fa-thumbs-up", label: "Like", category: "social" },
    { value: "fal fa-thumbs-down", label: "Dislike", category: "social" },
    { value: "fal fa-heart", label: "Heart", category: "social" },
    { value: "fal fa-star", label: "Star", category: "social" },
    { value: "fal fa-smile", label: "Smile", category: "social" },
    { value: "fal fa-meh", label: "Meh", category: "social" },
    { value: "fal fa-frown", label: "Frown", category: "social" },
    { value: "fal fa-share", label: "Share Arrow", category: "social" },
    { value: "fal fa-users-cog", label: "Users Cog", category: "social" },

    // --- CLIMA Y NATURALEZA ---
    { value: "fal fa-sun", label: "Sun", category: "weather" },
    { value: "fal fa-moon", label: "Moon", category: "weather" },
    { value: "fal fa-cloud", label: "Cloud", category: "weather" },
    { value: "fal fa-cloud-rain", label: "Rain", category: "weather" },
    {
      value: "fal fa-cloud-showers-heavy",
      label: "Heavy Rain",
      category: "weather",
    },
    { value: "fal fa-cloud-sun", label: "Cloudy Sun", category: "weather" },
    { value: "fal fa-snowflake", label: "Snow", category: "weather" },
    { value: "fal fa-bolt", label: "Lightning", category: "weather" },
    { value: "fal fa-wind", label: "Wind", category: "weather" },
    { value: "fal fa-umbrella", label: "Umbrella", category: "weather" },
    { value: "fal fa-leaf", label: "Leaf", category: "nature" },
    { value: "fal fa-tree", label: "Tree", category: "nature" },
    { value: "fal fa-seedling", label: "Seedling", category: "nature" },
    { value: "fal fa-fire", label: "Fire", category: "nature" },
    { value: "fal fa-water", label: "Water", category: "nature" },

    // --- MEDICINA Y SALUD ---
    { value: "fal fa-heartbeat", label: "Heartbeat", category: "medical" },
    { value: "fal fa-medkit", label: "Medkit", category: "medical" },
    { value: "fal fa-hospital", label: "Hospital", category: "medical" },
    { value: "fal fa-ambulance", label: "Ambulance", category: "medical" },
    { value: "fal fa-user-md", label: "Doctor", category: "medical" },
    { value: "fal fa-stethoscope", label: "Stethoscope", category: "medical" },
    { value: "fal fa-syringe", label: "Syringe", category: "medical" },
    { value: "fal fa-pills", label: "Pills", category: "medical" },
    {
      value: "fal fa-thermometer-half",
      label: "Thermometer",
      category: "medical",
    },
    { value: "fal fa-first-aid", label: "First Aid", category: "medical" },
    {
      value: "fal fa-file-medical",
      label: "Medical File",
      category: "medical",
    },

    // --- OBJETOS VARIOS ---
    { value: "fal fa-box", label: "Box", category: "misc" },
    { value: "fal fa-box-open", label: "Box Open", category: "misc" },
    { value: "fal fa-boxes", label: "Boxes", category: "misc" },
    { value: "fal fa-pallet", label: "Pallet", category: "misc" },
    { value: "fal fa-truck", label: "Truck", category: "misc" },
    { value: "fal fa-truck-loading", label: "Truck Loading", category: "misc" },
    { value: "fal fa-dolly", label: "Dolly", category: "misc" },
    { value: "fal fa-clipboard", label: "Clipboard", category: "misc" },
    {
      value: "fal fa-clipboard-list",
      label: "Clipboard List",
      category: "misc",
    },
    {
      value: "fal fa-clipboard-check",
      label: "Clipboard Check",
      category: "misc",
    },
    { value: "fal fa-paperclip", label: "Paperclip", category: "misc" },
    { value: "fal fa-thumbtack", label: "Pin Tack", category: "misc" },
    { value: "fal fa-coffee", label: "Coffee", category: "misc" },
    { value: "fal fa-mug-hot", label: "Mug", category: "misc" },
    { value: "fal fa-birthday-cake", label: "Cake", category: "misc" },
    { value: "fal fa-gift", label: "Gift", category: "misc" },
    { value: "fal fa-glass-cheers", label: "Cheers", category: "misc" },
    { value: "fal fa-graduation-cap", label: "Graduation", category: "misc" },
    { value: "fal fa-award", label: "Award", category: "misc" },
    { value: "fal fa-medal", label: "Medal", category: "misc" },
    { value: "fal fa-trophy", label: "Trophy", category: "misc" },
    { value: "fal fa-crown", label: "Crown", category: "misc" },
    { value: "fal fa-lightbulb", label: "Idea", category: "misc" },
    { value: "fal fa-rocket", label: "Rocket", category: "misc" },
    { value: "fal fa-bug", label: "Bug", category: "misc" },
    { value: "fal fa-gamepad", label: "Game", category: "misc" },
    { value: "fal fa-puzzle-piece", label: "Puzzle", category: "misc" },
    { value: "fal fa-magnet", label: "Magnet", category: "misc" },
    { value: "fal fa-bell", label: "Bell", category: "misc" },
    { value: "fal fa-magic", label: "Magic", category: "misc" },
  ];
}
